import Modal from "@client/controls/Modal/container";
import { type WithId } from "@client/types";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";
import { type MemberVouchers } from "../types";

export type MapProps = WithId & {
  item: MemberVouchers.Voucher | null;

  isVisible: boolean;
};

export type ActionProps = {
  onClose: () => void;
};

export type Props = ActionProps & MapProps;
export default (props: Props) => {
  const i18n = useI18n();

  return (
    <Modal
      hasBackdrop
      isAdminColor={false}
      isDraggable={false}
      isCentered
      isLoading={false}
      isVisible={props.isVisible}
      onClose={props.onClose}
    >
      <Modal.Header title={i18n.voucherCode} />
      <Modal.Body>{props.item ? <div>{props.item.voucherCode}</div> : null}</Modal.Body>
    </Modal>
  );
};
